import React from "react";
import { Link } from "react-router-dom";
import { defaultPfpUrl } from "../../utils";

/**
 * Tooltip card that appears on hover, styled like resultItems cards.
 * @param {{ item: object }} props
 * @returns {JSX.Element | null}
 */
const Tooltip = ({ item }) => {
    if (!item) return null;

    if (item.type === "location") {
        return (
            <div className="block min-w-[160px] max-w-[250px] rounded-lg border border-border bg-secondary p-4 shadow-lg">
                <div className="text-center text-base font-semibold text-text-primary">
                    {item.name || "Location"}
                </div>
            </div>
        );
    }

    const isUser = item.type === 'user'
    const name = isUser 
        ? (item.first_name && item.last_name ? `${item.first_name} ${item.last_name}` : item.username || "User")
        : (item.name || "Organization");

    // Get first affiliation if available (for users)
    const firstAffiliation = item.affiliations && item.affiliations.length > 0 ? item.affiliations[0] : null;
    const role = firstAffiliation ? firstAffiliation.role : null;
    const organization = firstAffiliation ? firstAffiliation.organization : null;

    const profileUrl = isUser ? `/profile/${item.id}` : `/organization/${item.id}`;

    return (
        <Link
            to={profileUrl}
            className="block bg-secondary rounded-lg shadow-lg border border-border p-4 min-w-[200px] max-w-[250px] hover:shadow-xl transition-shadow cursor-pointer"
            onClick={(e) => {
                // Stop event propagation to prevent map interactions
                e.stopPropagation();
            }}
        >
            {/* Profile Picture */}
            <div className="flex justify-center mb-3">
                <img
                    src={item.pfp_url || defaultPfpUrl}
                    alt={name}
                    className="w-16 h-16 rounded-full object-cover"
                    onError={(e) => {
                        e.target.src = defaultPfpUrl;
                    }}
                />
            </div>

            {/* Name */}
            <div className="font-semibold text-text-primary text-base mb-1 hover:text-accent transition-colors text-center">
                {name}
            </div>

            {/* Role (for users) */}
            {isUser && role && (
                <div className="text-sm text-accent mb-2 text-center">
                    {role}
                </div>
            )}

            {/* Organization (for users) */}
            {isUser && organization && (
                <div className="text-xs text-text-muted mb-2 text-center">
                    {organization.name}
                </div>
            )}

            {/* Location (for organizations) */}
            {!isUser && item.location && (
                <div className="text-sm text-text-secondary mb-2 text-center">
                    {item.location}
                </div>
            )}

            {/* Mission Statement (for organizations) */}
            {!isUser && item.mission_statement && (
                <div className="text-xs text-text-muted line-clamp-2 text-center">
                    "{item.mission_statement}"
                </div>
            )}
        </Link>
    );
};

export default Tooltip;
